var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center",style:({..._vm.fullPaddingSubject(_vm.section.options.content.carousel, 'padding', [20,20,20,20]), ..._vm.fullMarginSubject(_vm.section.options.content.carousel)})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }